import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { fetchFinanceOverview, getApiErrorMessage } from "../../api";
import { currentMonthIso } from "./financeUtils";

export default function useFinanceOverview() {
  const [searchParams, setSearchParams] = useSearchParams();
  const month = searchParams.get("month") || currentMonthIso();
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const setMonth = useCallback((nextMonth) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("month", nextMonth);
      return next;
    }, { replace: true });
  }, [setSearchParams]);

  const reload = useCallback(async () => {
    try {
      const data = await fetchFinanceOverview({ month });
      setOverview(data);
      setError("");
    } catch (err) {
      setError(getApiErrorMessage(err, "Не удалось загрузить кассу"));
    } finally {
      setLoading(false);
    }
  }, [month]);

  useEffect(() => {
    setLoading(true);
    reload();
  }, [reload]);

  return { month, setMonth, overview, loading, error, reload };
}
